export function toWhatsAppNumber(rawPhone: string): string {
  const digits = rawPhone.replace(/\D/g, '')
  if (!digits) return ''

  // South African local format fallback: 0XXXXXXXXX -> 27XXXXXXXXX
  if (digits.startsWith('0')) {
    return `27${digits.slice(1)}`
  }

  return digits
}

export function toWhatsAppHref(rawPhone: string): string {
  return `https://wa.me/${toWhatsAppNumber(rawPhone)}`
}
